import base from './baseOptions';
import formatFloat from '../../../api/getChartSeries/formatFloat';
import buildDrillDown from '../../../buildDrillDown';

const pie = ({
  formatMetric,
  title,
  precision,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
  innerSize,
}) => ({
  ...base(formatMetric),
  chart: {
    ...base.chart,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
  },
  title: {
    ...base(formatMetric).title,
    text: title,
  },
  plotOptions: {
    pie: {
      borderRadius: '0px',
      innerSize: innerSize ?? '50%',
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        formatter: function () {
          const name = this.point.name;
          // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables
          // This color will need dark mode handling via Highcharts theme system
          return `<span style="color: var(--color-text-primary)">${name}</span>`;
        },
        style: {
          fontSize,
        },
      },

      showInLegend: true,
      point: {
        events: {
          click: function (e) {
            const terms = e.point.series.data;
            const selectedIndex = e.point.x;

            if (openMenu) {
              const { metricIds } = this.series.userOptions;
              const selectedTerm = terms.find((t, index) => {
                return index === selectedIndex;
              });
              openMenu(
                metricIds,
                buildDrillDown(
                  groupField,
                  fieldType,
                  selectedTerm.name,
                  chartDef,
                ),
              );
            } else {
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              onDrillDown(terms[selectedIndex].name, e.ctrlKey || e.metaKey);
            }
          },
        },
      },
    },
  },

  legend: {
    ...base(formatMetric).legend,
    enabled: false,
    verticalAlign: 'bottom',
    align: 'left',
    y: 68,
    style: {
      labels: {
        fontSize,
      },
    },
  },

  tooltip: {
    ...base(formatMetric).tooltip,
    pointFormatter: function () {
      const seriesname = this.series.name;
      const value = formatFloat(this.y, precision);
      // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables
      // This color will need dark mode handling via Highcharts theme system
      return `<span style="color:{point.color};">\u25CF </span><b><span style="color: var(--color-text-muted);">${seriesname}</span><b> ${value}%</b><br/>`;
    },
  },
});

export default pie;
